import { useNavigate } from 'react-router-dom'

import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { routes } from '@frame/routes'

import { useRootContext } from '../context'
import { isMarkedComplete } from '../utils/tasks'
import { useAutoNavigate } from './useAutoNavigate'

export function useVerifyViaCredentials(): (taskId: string) => Promise<DirectTask | undefined> {
  const { mutateAndNavigate } = useAutoNavigate()
  const navigate = useNavigate()
  const { actions } = useRootContext()

  async function verify(taskId: string): Promise<DirectTask | undefined> {
    const preparedTask = await actions.addStrategyToDirectTask({
      strategy: TrueworkJsStrategy.CREDENTIALS,
      directTaskId: taskId,
    })

    if (!preparedTask) {
      throw new Error('Failed to add credentials strategy to task')
    }

    if (isMarkedComplete(preparedTask)) {
      mutateAndNavigate()
      return preparedTask
    }

    if (preparedTask.connector_company_identifier) {
      navigate(`${routes.credentials}/${preparedTask.id}?item_id=${preparedTask.connector_company_identifier}`, {
        state: {
          task: preparedTask,
        },
      })
    } else {
      navigate(`${routes.credentials}/${preparedTask.id}`, { state: { task: preparedTask } })
    }

    return preparedTask
  }

  return verify
}
